enum EAppRoutes {
  LOGIN = '/',
  SIGN_UP = 'signup',
  FANZA = '/fanza',
  FANZA_SIGN_UP = '/fanza/signup',
  LOGOUT = 'logout',
  FANZA_LOGOUT = 'fanza/logout',
  PERSONAL_AREA = 'personal-area',
  ORDER_HISTORY = 'personal-area/order-history',
  PROFILE = 'user-details',
}

export { EAppRoutes }
